import React, { LegacyRef, ReactNode } from 'react';

interface ICommonTypeFilterButton {
    isChecked: boolean;
    onClick: () => void;
    children: ReactNode;
}

const Button: React.ForwardRefExoticComponent<
    ICommonTypeFilterButton & React.RefAttributes<HTMLButtonElement>
> = React.forwardRef(
    (
        { isChecked, onClick, children }: ICommonTypeFilterButton,
        ref: LegacyRef<HTMLButtonElement>,
    ) => (
        <button
            ref={ref}
            type="button"
            className={`text-base pb-[16px] mb-[-1px] text-brandBlue-300 ${
                isChecked ? 'text-brandBlue-500 border-solid border-b-[2px] border-brandColor' : ''
            }`}
            onClick={onClick}
        >
            {children}
        </button>
    ),
);

export default Button;
